// removed by extract-text-webpack-plugin
module.exports = {"App":"App__App__2wozK","App-logo":"App__App-logo__3ZtW2","App-logo-spin":"App__App-logo-spin__1crW4","App-header":"App__App-header__17Nww","App-title":"App__App-title__2njjh","App-intro":"App__App-intro__qTUIn"};


//////////////////
// WEBPACK FOOTER
// ./src/Containers/App.css
// module id = 117
// module chunks = 0